// src/firebase-config.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";

// Firebase configuration object (replace with your own Firebase project details)
const firebaseConfig = {
    apiKey: "AIzaSyBw2Qbzb6kH2r7q3HRfuKdZSGu3MP5zSs4",
    authDomain: "brickbucket-f8afe.firebaseapp.com",
    projectId: "brickbucket-f8afe",
    storageBucket: "brickbucket-f8afe.firebasestorage.app",
    messagingSenderId: "your-sender-id",
    appId: "1:806653185362:web:fa80e74257e957a1837e8b",
    measurementId: "G-3M4ZGDBGJK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
//const messaging = getMessaging(app);

// ✅ Only create messaging if supported
const messagingPromise = isSupported().then((supported) => {
    if (supported) {
        const messaging = getMessaging(app);
        return messaging;
    } else {
        console.warn("Firebase Messaging is not supported in this browser.");
        return null;
    }
});

export { /* messaging , */ messagingPromise, getToken, onMessage };
